import { getHeaders, makeRequest } from "$utils/utils";
import config from "$services/config";

const { shipping_api_url: shipping_url } = config;

export const getShippingRecorDispute = async (token: string, id: string) => {
  try {
    const res = await makeRequest(
      `${shipping_url}/disputes/${id}`,
      "GET",
      undefined,
      getHeaders(token)
    );
    return res.data;
  } catch (error: any) {
    return { error };
  }
};

export const updateShippingRecorDispute = async (
  token: string,
  id: string,
  body: any
) => {
  try {
    const res = await makeRequest(
      `${shipping_url}/disputes/${id}`,
      "PUT",
      body,
      getHeaders(token)
    );
    return res.data;
  } catch (error: any) {
    return { error };
  }
};

export const createShippingRecorDispute = async (token: string, body: any) => {
  try {
    const res = await makeRequest(
      `${shipping_url}/disputes`,
      "POST",
      body,
      getHeaders(token)
    );
    return res.data;
  } catch (error: any) {
    return { error };
  }
};
